var win = window;

export var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };



//////////////////
// WEBPACK FOOTER
// /Users/patrikkarlsson/www/gunnebo/node_modules/tiny-slider/src/helpers/raf.js
// module id = 98
// module chunks = 0